/**
 * FragmentRenderer — Magic MD 片段解析渲染。
 *
 * 将 ContinuationTarget.Fragment 的 source 文本通过 parseMagicMd
 * 解析为 blocks 并渲染。policy="safe" 时过滤禁止的语法元素。
 */

import type { DocumentBlock } from "@magic-md/core";
import { parseMagicMd } from "@magic-md/core";
import { memo, useMemo } from "react";
import { BlockList } from "../document-renderer/blocks/BlockList";

/** 安全策略下允许的 block 类型 */
const SAFE_BLOCK_TYPES = new Set<DocumentBlock["type"]>([
    "markdown",
    "block-render",
    "inline-render",
    "inline-ref",
]);

export const FragmentRenderer = memo(function FragmentRenderer({
    source,
    policy,
}: {
    source: string;
    policy: "safe" | "full";
    mode: "inline" | "block";
}) {
    const blocks = useMemo<DocumentBlock[]>(() => {
        if (!source) return [];
        try {
            const parsed = parseMagicMd(source);
            if (policy === "safe") {
                return parsed.blocks.filter((b) => SAFE_BLOCK_TYPES.has(b.type));
            }
            return parsed.blocks;
        } catch {
            return [{ type: "markdown" as const, content: source }];
        }
    }, [source, policy]);

    if (blocks.length === 0) return null;

    return (
        <BlockList blocks={blocks} className="preview-content prose prose-sm max-w-none" />
    );
});
